import api from './api';

export default {
    async resetPassowrdEmail(payload) {
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/password/forgot-password',payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao gerar email para resetar a senha:', error);
            throw error;
        }
    },
    
    async resetPassowrd(payload){
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/password/change-password', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao atualizar senha:', error);
            throw error;
        }
    },

    async activateAccount(payload){
        try {
            const headers = {
                'Content-Type': 'application/json', 
            };
            const response = await api.post('/password/change-password', payload, {
                headers,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao ativar conta:', error);
            throw error;
        }
    },

    async changeSuperAdminPassword(payload) {
        try {
            const response = await api.post('/password/super-admin/change-password', payload, {
                headers: { 'Content-Type': 'application/json' },
                skipAuthRecovery: true,
            });
            return response.data;
        } catch (error) {
            console.error('Erro ao definir senha de super admin:', error);
            throw error;
        }
    },


}

